import { Component, Input } from '@angular/core';
import { IAddress } from '@mavles/contacts';

@Component({
    selector: 'app-address-view',
    templateUrl: './address-view.component.html',
    styleUrl: './address-view.component.scss',
    standalone: false
})
export class AddressViewComponent {
  @Input() address!: IAddress;
}


